<app-loader *ngIf="isDisabled"></app-loader>
<div class="card" style="min-height: 100%;">
    <div class="card-header">
        <div class="row">
            <div class="col">
                Employee {{GetID == 1?'Approval':'Request'}}
            </div>
            <div class="col-auto">
                <span class="badge"
                    [ngClass]="{'success': common.ToLowerCase(DetailData.ApprovalStatus) == 'approved', 'danger':common.ToLowerCase(DetailData.ApprovalStatus) == 'rejected','warning':common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' || common.ToLowerCase(DetailData.ApprovalStatus) == 'reInitiated' || common.ToLowerCase(DetailData.ApprovalStatus) == 'pendingwithsenior'}">{{DetailData.ApprovalStatus}}</span>
            </div>
        </div>
    </div>
    <div class="card-body p-0">
        <div class="row g-0">
            <div class="col-md-7">
                <div class="card">
                    <div class="card-body p-1">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="row" style="align-items: center;line-height: normal;">
                                    <div class="col-2">
                                        <img *ngIf="DetailData.Photo != null && DetailData.Photo != ''" mat-card-image
                                            class="userImage" [src]="common.PhotoLink(DetailData.Photo)" />
                                        <div *ngIf="DetailData.Photo == null || DetailData.Photo == ''"
                                            class="initial-image">
                                            <div class="image">
                                                {{common.getInitial(DetailData.EmployeeName)}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-9 userdetail">
                                        <label class="form-label"
                                            style="font-size: 13px!important;font-weight: 500; margin-bottom: 0;color: #191d4a;">{{DetailData.EmployeeName}}</label><br />
                                        <label class="form-label"
                                            style="font-size: 10px!important;font-weight: 500; margin-bottom: 0;color: #aaaab2;">#{{DetailData.EmpCode}}</label><br />
                                        <!-- <label class="form-label"
                                            style="font-size: 10px!important;font-weight: 500; margin-bottom: 0;color: #aaaab2;">{{DetailData.DesignationName}}</label> -->
                                    </div>
                                </div>
                            </div>
                            <div class="col"></div>
                            <div class="col-auto text-end">
                                <label for="RequestDate" class="text-label-light">Request Date</label> <br />
                                <label name="RequestDate" class="text-label-dark">{{DetailData.RequestDate}}</label>
                            </div>
                        </div>
                        <div style="background-color:#0078d42e;border-radius: 5px;" class="p-2 mb-2">
                            <div class="row">
                                <!-- <div class="col-md-4">
                                    <label for="ToDate" class="text-label-light">MonthYear</label> <br />
                                    <label name="ToDate" class="text-label-dark">{{DetailData.MonthYear }}</label>
                                </div> -->

                            </div>
                        </div>
                        <div style="background-color:#8080800f;border-radius: 5px;" class="p-2 mb-2">
                            <div class="row">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{common.ToLowerCase(DetailData.EmpType)
                                        ==
                                        'front'?'Client Location' :common.ToLowerCase(DetailData.EmpType) ==
                                        'back'?'Branch':''}}</label>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{common.ToLowerCase(DetailData.EmpType)
                                        ==
                                        'front'?DetailData.ClientLocation :common.ToLowerCase(DetailData.EmpType) ==
                                        'back'?DetailData.BranchName:''}}</label>
                                </div>
                            </div>
                            <!-- <div class="row">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Client Location</label>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{DetailData.ClientLocation}}</label>
                                </div>
                            </div> -->
                            <div class="row">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Designation</label>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{DetailData.DesignationName}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-5 ps-1">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 p-0">
                            <div class="card">
                                <label class="m-2" *ngIf="!isApprovalLavel">{{tooltip.NoApprovalLevel}}</label>
                                <div class="card-body" *ngIf="isApprovalLavel">
                                    <div id="content">
                                        <ul class="timeline">
                                            <li class="event p-0 m-0" *ngFor="let Tracking of TrackingsUser">
                                                <div class="row align-items-center">
                                                    <div class="col-2">
                                                        <img *ngIf="Tracking['Photo'] != null && Tracking['Photo'] != ''"
                                                            mat-card-image class="userImage"
                                                            [src]="common.PhotoLink(Tracking['Photo'])" />
                                                        <div *ngIf="Tracking['Photo'] == null || Tracking['Photo'] == ''"
                                                            class="initial-image">
                                                            <div class="image">
                                                                {{common.getInitial(Tracking['ApproverName'])}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col">
                                                        <h3 class="m-0">
                                                            {{Tracking['ApproverName']}}({{Tracking['ApprovalStage']}})
                                                        </h3>
                                                    </div>
                                                    <div class="col-auto"><span class="badge"
                                                            [ngClass]="{'success': (common.ToLowerCase(Tracking['Status']) == 'approved' || common.ToLowerCase(Tracking['Status']) == 'autoapproved'), 'danger':common.ToLowerCase(Tracking['Status']) == 'rejected','warning':common.ToLowerCase(Tracking['Status']) == 'pending' || common.ToLowerCase(Tracking['Status']) == 'reInitiated'}">{{Tracking['Status']}}</span>
                                                    </div>
                                                </div>
                                                <label class="date">{{Tracking['ActionDate']}}</label>
                                                <p class="remark">{{Tracking['Remark']}}</p>
                                                <input type="text" class="form-control" placeholder="Remark" id="Remark"
                                                    name="LocalCity" [(ngModel)]="Filter.Remark" #Remark="ngModel"
                                                    *ngIf="common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(Tracking['Status']) == 'pending' && GetID == 1">
                                                <hr />
                                            </li>
                                            <li class="event p-0 m-0" *ngFor="let Tracking of Trackings">
                                                <div class="row align-items-center">
                                                    <div class="col-2">
                                                        <img *ngIf="Tracking['Photo'] != null && Tracking['Photo'] != ''"
                                                            mat-card-image class="userImage"
                                                            [src]="common.PhotoLink(Tracking['Photo'])" />
                                                        <div *ngIf="Tracking['Photo'] == null || Tracking['Photo'] == ''"
                                                            class="initial-image">
                                                            <div class="image">
                                                                {{common.getInitial(Tracking['ApproverName'])}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col">
                                                        <h3>{{Tracking['ApproverName']}}({{Tracking['ApprovalStage']}})
                                                        </h3>
                                                    </div>
                                                    <div class="col-auto"><span class="badge"
                                                            [ngClass]="{'success': (common.ToLowerCase(Tracking['Status']) == 'approved' || common.ToLowerCase(Tracking['Status']) == 'autoapproved'), 'danger':common.ToLowerCase(Tracking['Status']) == 'rejected','warning':common.ToLowerCase(Tracking['Status']) == 'pending' || common.ToLowerCase(Tracking['Status']) == 'reInitiated'}">{{Tracking['Status']}}</span>
                                                    </div>
                                                </div>
                                                <label class="date">{{Tracking['ActionDate']}}</label>
                                                <p class="remark">{{Tracking['Remark']}}</p>
                                            </li>
                                            <li class="event p-0 m-0">
                                                <div class="row">
                                                    <h3>Submitted on</h3>
                                                </div>
                                                <label class="date">{{DetailData.RequestDate}}</label>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row g-0">
            <div *ngIf="OperationType === 'PermanentAddress'">
                <div class="modal-container">
                    <!-- Header -->
                    <div class="modal-header">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <h4 class="mb-1"><i class="bi bi-house me-2"></i>Permanent Address</h4>
                                <p class="mb-0 opacity-75">Review details before approval</p>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="dashboard">
                            <div class="card previous" style="border-radius: 4px;margin: 0.5rem;">
                                <div class="card-header">
                                    <div class="icon">P</div>
                                    <h2>Previous Permanent Address</h2>
                                </div>
                                <div class="table-container">
                                    <table id="previousTable">
                                        <thead>
                                            <tr>
                                                <th>NativeAddress1</th>
                                                <th>NativeAddress2</th>
                                                <th>Village City</th>
                                                <th>State Name</th>
                                                <th>District Name</th>
                                                <th>Taluka Name</th>
                                                <th>Pincode</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let data of EmpOldDocDetail; let i = index">
                                                <td>{{data['NativeAddress1']}}</td>
                                                <td>{{data['NativeAddress2']}}</td>
                                                <td>{{data['VillageCity']}}</td>
                                                <td>{{data['StateName']}}</td>
                                                <td>{{data['DistrictName']}}</td>
                                                <td>{{data['TalukaName']}}</td>
                                                <td>{{data['Pincode']}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="card previous" style="border-radius: 4px;margin: 0.5rem;">
                                <div class="card-header">
                                    <div class="icon">N</div>
                                    <h2>New Permanent Address</h2>
                                </div>
                                <div class="table-container">
                                    <table id="newTable">
                                        <thead>
                                            <tr>
                                                <th>NativeAddress1</th>
                                                <th>NativeAddress2</th>
                                                <th>Village City</th>
                                                <th>State Name</th>
                                                <th>District Name</th>
                                                <th>Taluka Name</th>
                                                <th>Pincode</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let data of EmpNewDocDetail; let i = index">
                                                <td>{{data['NativeAddress1']}}</td>
                                                <td>{{data['NativeAddress2']}}</td>
                                                <td>{{data['VillageCity']}}</td>
                                                <td>{{data['StateName']}}</td>
                                                <td>{{data['DistrictName']}}</td>
                                                <td>{{data['TalukaName']}}</td>
                                                <td>{{data['Pincode']}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="OperationType === 'CurrentAddress'">
                <div class="modal-container">
                    <!-- Header -->
                    <div class="modal-header">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <h4 class="mb-1"><i class="bi bi-house me-2"></i>Current Address</h4>
                                <p class="mb-0 opacity-75">Review details before approval</p>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="dashboard">
                            <div class="card previous" style="border-radius: 4px;margin: 0.5rem;">
                                <div class="card-header">
                                    <div class="icon">P</div>
                                    <h2>Previous Current Address</h2>
                                </div>
                                <div class="table-container">
                                    <table id="previousTable">
                                        <thead>
                                            <tr>
                                                <th>LocalAddress1</th>
                                                <th>LocalAddress2</th>
                                                <th>Village City</th>
                                                <th>State Name</th>
                                                <th>District Name</th>
                                                <th>Taluka Name</th>
                                                <th>Pincode</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let data of EmpOldDocDetail; let i = index">
                                                <td>{{data['LocalAddress1']}}</td>
                                                <td>{{data['LocalAddress2']}}</td>
                                                <td>{{data['VillageCity']}}</td>
                                                <td>{{data['StateName']}}</td>
                                                <td>{{data['DistrictName']}}</td>
                                                <td>{{data['TalukaName']}}</td>
                                                <td>{{data['Pincode']}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="card previous" style="border-radius: 4px;margin: 0.5rem;">
                                <div class="card-header">
                                    <div class="icon">N</div>
                                    <h2>New Current Address</h2>
                                </div>
                                <div class="table-container">
                                    <table id="newTable">
                                        <thead>
                                            <tr>
                                                <th>LocalAddress1</th>
                                                <th>LocalAddress2</th>
                                                <th>Village City</th>
                                                <th>State Name</th>
                                                <th>District Name</th>
                                                <th>Taluka Name</th>
                                                <th>Pincode</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let data of EmpNewDocDetail; let i = index">
                                                <td>{{data['LocalAddress1']}}</td>
                                                <td>{{data['LocalAddress2']}}</td>
                                                <td>{{data['VillageCity']}}</td>
                                                <td>{{data['StateName']}}</td>
                                                <td>{{data['DistrictName']}}</td>
                                                <td>{{data['TalukaName']}}</td>
                                                <td>{{data['Pincode']}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="OperationType === 'Details'">
                <div class="modal-container">
                    <!-- Header -->
                    <div class="modal-header">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <h4 class="mb-1"><i class="bi bi-person-badge me-2"></i>User Details Comparison</h4>
                                <p class="mb-0 opacity-75">Review changes before approval</p>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="comparison-grid">
                            <div class="version-panel previous">
                                <div class="version-header">
                                    <span class="version-badge badge-previous">
                                        <i class="bi bi-clock-history me-1"></i> PREVIOUS
                                    </span>
                                    <span class="text-muted">Original details</span>
                                </div>

                                <div class="user-card">
                                    <div class="user-avatar">
                                        <img *ngIf="EmpOldDocDetail[0]['Image'] != null && EmpOldDocDetail[0]['Image'] != ''"
                                            mat-card-image class="userImage"
                                            [src]="common.PhotoLink(EmpOldDocDetail[0]['Image'])"
                                            (click)="common.FullImage('',{'ProfileImage':common.PhotoLink(EmpOldDocDetail[0]['Image'])})" />
                                        <div *ngIf="EmpOldDocDetail[0]['Image'] == null || EmpOldDocDetail[0]['Image'] == ''"
                                            class="initial-image">
                                            <div class="image">
                                                {{common.getInitial(EmpOldDocDetail[0]['FirstName'] + ' ' +
                                                EmpOldDocDetail[0]['LastName'])}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="detail-list">
                                        <div class="detail-item">
                                            <span class="detail-label">First Name</span>
                                            <span class="detail-value">{{EmpOldDocDetail[0]['FirstName']}}</span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">Middle Name</span>
                                            <span class="detail-value">{{EmpOldDocDetail[0]['MiddleName']}}</span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">Last Name</span>
                                            <span class="detail-value">{{EmpOldDocDetail[0]['LastName']}}</span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">Gender</span>
                                            <span class="detail-value">{{EmpOldDocDetail[0]['GenderName']}}</span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">Birth Date</span>
                                            <span class="detail-value">{{EmpOldDocDetail[0]['BirthDate']}}</span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">Father/Husband Name</span>
                                            <span
                                                class="detail-value">{{EmpOldDocDetail[0]['FatherHusbANDName']}}</span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">Marital Status</span>
                                            <span
                                                class="detail-value">{{EmpOldDocDetail[0]['MartialStatusName']}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="version-panel new">
                                <div class="version-header">
                                    <span class="version-badge badge-new">
                                        <i class="bi bi-arrow-up-circle me-1"></i> NEW
                                    </span>
                                    <span class="text-muted">Updated details</span>
                                </div>

                                <div class="user-card">
                                    <div class="user-avatar">
                                        <img *ngIf="EmpNewDocDetail[0]['Image'] != null && EmpNewDocDetail[0]['Image'] != ''"
                                            mat-card-image class="userImage"
                                            [src]="common.PhotoLink(EmpNewDocDetail[0]['Image'])"
                                            (click)="common.FullImage('',{'ProfileImage':common.PhotoLink(EmpNewDocDetail[0]['Image'])})" />
                                        <div *ngIf="EmpNewDocDetail[0]['Image'] == null || EmpNewDocDetail[0]['Image'] == ''"
                                            class="initial-image">
                                            <div class="image">
                                                {{common.getInitial(EmpNewDocDetail[0]['FirstName'] + ' ' +
                                                EmpNewDocDetail[0]['LastName'])}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="detail-list">
                                        <div class="detail-item">
                                            <span class="detail-label">First Name</span>
                                            <span class="detail-value"
                                                [ngClass]="{'changed-value': EmpNewDocDetail[0]['FirstName'] != EmpOldDocDetail[0]['FirstName']}">{{EmpNewDocDetail[0]['FirstName']}}
                                                <span class="change-indicator" title="Changed"
                                                    *ngIf="EmpNewDocDetail[0]['FirstName'] != EmpOldDocDetail[0]['FirstName']">
                                                    <i class="bi bi-exclamation"></i>
                                                </span>
                                            </span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">Middle Name</span>
                                            <span class="detail-value"
                                                [ngClass]="{'changed-value': EmpNewDocDetail[0]['MiddleName'] != EmpOldDocDetail[0]['MiddleName']}">{{EmpNewDocDetail[0]['MiddleName']}}
                                                <span class="change-indicator" title="Changed"
                                                    *ngIf="EmpNewDocDetail[0]['MiddleName'] != EmpOldDocDetail[0]['MiddleName']">
                                                    <i class="bi bi-exclamation"></i>
                                                </span>
                                            </span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">Last Name</span>
                                            <span class="detail-value"
                                                [ngClass]="{'changed-value': EmpNewDocDetail[0]['LastName'] != EmpOldDocDetail[0]['LastName']}">{{EmpNewDocDetail[0]['LastName']}}
                                                <span class="change-indicator" title="Changed"
                                                    *ngIf="EmpNewDocDetail[0]['LastName'] != EmpOldDocDetail[0]['LastName']">
                                                    <i class="bi bi-exclamation"></i>
                                                </span>
                                            </span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">Gender</span>
                                            <span class="detail-value"
                                                [ngClass]="{'changed-value': EmpNewDocDetail[0]['GenderName'] != EmpOldDocDetail[0]['GenderName']}">
                                                {{EmpNewDocDetail[0]['GenderName']}}
                                                <span class="change-indicator" title="Changed"
                                                    *ngIf="EmpNewDocDetail[0]['GenderName'] != EmpOldDocDetail[0]['GenderName']">
                                                    <i class="bi bi-exclamation"></i>
                                                </span>
                                            </span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">Birth Date</span>
                                            <span class="detail-value"
                                                [ngClass]="{'changed-value': EmpNewDocDetail[0]['BirthDate'] != EmpOldDocDetail[0]['BirthDate']}">{{EmpNewDocDetail[0]['BirthDate']}}
                                                <span class="change-indicator" title="Changed"
                                                    *ngIf="EmpNewDocDetail[0]['BirthDate'] != EmpOldDocDetail[0]['BirthDate']">
                                                    <i class="bi bi-exclamation"></i>
                                                </span>
                                            </span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">Father/Husband Name</span>
                                            <span class="detail-value"
                                                [ngClass]="{'changed-value': EmpNewDocDetail[0]['FatherHusbANDName'] != EmpOldDocDetail[0]['FatherHusbANDName']}">{{EmpNewDocDetail[0]['FatherHusbANDName']}}
                                                <span class="change-indicator" title="Changed"
                                                    *ngIf="EmpNewDocDetail[0]['FatherHusbANDName'] != EmpOldDocDetail[0]['FatherHusbANDName']">
                                                    <i class="bi bi-exclamation"></i>
                                                </span>
                                            </span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">Marital Status</span>
                                            <span class="detail-value"
                                                [ngClass]="{'changed-value': EmpNewDocDetail[0]['MartialStatusName'] != EmpOldDocDetail[0]['MartialStatusName']}">{{EmpNewDocDetail[0]['MartialStatusName']}}
                                                <span class="change-indicator" title="Changed"
                                                    *ngIf="EmpNewDocDetail[0]['MartialStatusName'] != EmpOldDocDetail[0]['MartialStatusName']">
                                                    <i class="bi bi-exclamation"></i>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="OperationType === 'Qualification'">
                <div class="modal-container">
                    <!-- Header -->
                    <div class="modal-header">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <h4 class="mb-1"><i class="bi bi-mortarboard-fill me-2"></i>Qualification</h4>
                                <p class="mb-0 opacity-75">Review details before approval</p>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="dashboard">
                            <div class="card previous" style="border-radius: 4px;margin: 0.5rem;">
                                <div class="card-header">
                                    <div class="icon">P</div>
                                    <h2>Previous Qualification</h2>
                                </div>
                                <div class="table-container">
                                    <table id="previousTable">
                                        <thead>
                                            <tr>
                                                <th>Qualification Name</th>
                                                <th>University Board</th>
                                                <th>Year Of Passing</th>
                                                <th>Percentage</th>
                                                <th>Grade Class</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let data of EmpOldDocDetail; let i = index">
                                                <td>{{data['QualificationName']}}</td>
                                                <td>{{data['UniversityBoard']}}</td>
                                                <td>{{data['YearOfPassing']}}</td>
                                                <td>{{data['Percentage']}}</td>
                                                <td>{{data['GradeClass']}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="card previous" style="border-radius: 4px;margin: 0.5rem;">
                                <div class="card-header">
                                    <div class="icon">N</div>
                                    <h2>New Qualification</h2>
                                </div>
                                <div class="table-container">
                                    <table id="newTable">
                                        <thead>
                                            <tr>
                                                <th>Qualification Name</th>
                                                <th>University Board</th>
                                                <th>Year Of Passing</th>
                                                <th>Percentage</th>
                                                <th>Grade Class</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let data of EmpNewDocDetail; let i = index">
                                                <td>{{data['QualificationName']}}</td>
                                                <td>{{data['UniversityBoard']}}</td>
                                                <td>{{data['YearOfPassing']}}</td>
                                                <td>{{data['Percentage']}}</td>
                                                <td>{{data['GradeClass']}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="OperationType === 'Bank'">
                <div class="modal-container">
                    <!-- Header -->
                    <div class="modal-header">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <h4 class="mb-1"><i class="bi bi-credit-card me-2"></i>Payment Details Comparison</h4>
                                <p class="mb-0 opacity-75">Review payment method changes before approval</p>
                            </div>
                        </div>
                    </div>

                    <!-- Body -->
                    <div class="modal-body">
                        <div class="comparison-grid">
                            <!-- Previous Version -->
                            <div class="version-panel previous">
                                <div class="version-header">
                                    <span class="version-badge badge-previous">
                                        <i class="bi bi-clock-history me-1"></i> PREVIOUS
                                    </span>
                                    <span class="text-muted">Original payment method</span>
                                </div>

                                <div class="payment-card">
                                    <div class="payment-icon icon-cash">
                                        <i class="bi bi-cash-coin"></i>
                                    </div>

                                    <div class="detail-list">
                                        <div class="detail-item">
                                            <span class="detail-label">Payment Mode</span>
                                            <span class="detail-value">
                                                {{EmpOldDocDetail[0].PaymentModeName}}
                                            </span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">Bank Name</span>
                                            <span class="detail-value">
                                                {{EmpOldDocDetail[0].BankName}}
                                            </span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">Bank Branch</span>
                                            <span class="detail-value">
                                                {{EmpOldDocDetail[0].BankBranchName}}
                                            </span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">IFSC Code</span>
                                            <span class="detail-value">
                                                {{EmpOldDocDetail[0].IFSCode}}
                                            </span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">Account No.</span>
                                            <span class="detail-value">
                                                {{EmpOldDocDetail[0].BankAccountNo}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- New Version -->
                            <div class="version-panel new">
                                <div class="version-header">
                                    <span class="version-badge badge-new">
                                        <i class="bi bi-arrow-up-circle me-1"></i> NEW
                                    </span>
                                    <span class="text-muted">Updated payment method</span>
                                </div>

                                <div class="payment-card">
                                    <div class="payment-icon icon-bank">
                                        <i class="bi bi-bank2"></i>
                                    </div>

                                    <div class="detail-list">
                                        <div class="detail-item">
                                            <span class="detail-label">Payment Mode</span>
                                            <span class="detail-value"
                                                [ngClass]="{'changed-value': EmpNewDocDetail[0].PaymentModeName != EmpOldDocDetail[0].PaymentModeName}">
                                                {{EmpNewDocDetail[0].PaymentModeName}}
                                                <span class="change-indicator" title="Changed"
                                                    *ngIf="EmpNewDocDetail[0].PaymentModeName != EmpOldDocDetail[0].PaymentModeName">
                                                    <i class="bi bi-exclamation"></i>
                                                </span>
                                            </span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">Bank Name</span>
                                            <span class="detail-value"
                                                [ngClass]="{'changed-value': EmpNewDocDetail[0].BankName != EmpOldDocDetail[0].BankName}">
                                                {{EmpNewDocDetail[0].BankName}}
                                                <span class="change-indicator" title="Changed"
                                                    *ngIf="EmpNewDocDetail[0].BankName != EmpOldDocDetail[0].BankName">
                                                    <i class="bi bi-exclamation"></i>
                                                </span>
                                            </span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">Bank Branch</span>
                                            <span class="detail-value"
                                                [ngClass]="{'changed-value': EmpNewDocDetail[0].BankBranchName != EmpOldDocDetail[0].BankBranchName}">
                                                {{EmpNewDocDetail[0].BankBranchName}}
                                                <span class="change-indicator" title="Changed"
                                                    *ngIf="EmpNewDocDetail[0].BankBranchName != EmpOldDocDetail[0].BankBranchName">
                                                    <i class="bi bi-exclamation"></i>
                                                </span>
                                            </span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">IFSC Code</span>
                                            <span class="detail-value"
                                                [ngClass]="{'changed-value': EmpNewDocDetail[0].IFSCode != EmpOldDocDetail[0].IFSCode}">
                                                {{EmpNewDocDetail[0].IFSCode}}
                                                <span class="change-indicator" title="Changed"
                                                    *ngIf="EmpNewDocDetail[0].IFSCode != EmpOldDocDetail[0].IFSCode">
                                                    <i class="bi bi-exclamation"></i>
                                                </span>
                                            </span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">Account No.</span>
                                            <span class="detail-value"
                                                [ngClass]="{'changed-value': EmpNewDocDetail[0].BankAccountNo != EmpOldDocDetail[0].BankAccountNo}">
                                                {{EmpNewDocDetail[0].BankAccountNo}}
                                                <span class="change-indicator" title="Changed"
                                                    *ngIf="EmpNewDocDetail[0].BankAccountNo != EmpOldDocDetail[0].BankAccountNo">
                                                    <i class="bi bi-exclamation"></i>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="OperationType === 'Document'">
                <div class="modal-container">
                    <!-- Header -->
                    <div class="modal-header">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <h4 class="mb-1"><i class="bi bi-files me-2"></i>Document Details Comparison</h4>
                                <p class="mb-0 opacity-75">Review document changes before approval</p>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="comparison-grid">
                            <div class="version-panel previous">
                                <div class="version-header">
                                    <span class="version-badge badge-previous">
                                        <i class="bi bi-clock-history me-1"></i> PREVIOUS
                                    </span>
                                    <span class="text-muted">Original documents</span>
                                </div>

                                <div class="documents-section">
                                    <div class="document-item" *ngFor="let doc of EmpOldDocDetail; let i = index">
                                        <div class="document-icon" [ngClass]="{'icon-pdf': (this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'pdf' || this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'doc' || this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'docx'),
                                            'icon-image': (this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'jpg' || this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'jpeg' || this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'png'),
                                            'icon-excel': (this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'xls' || this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'xlsx')
                                         }">
                                            <i class="bi" [ngClass]="{'bi-file-earmark-pdf': (this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'pdf' || this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'doc' || this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'docx'),
                                            'bi-file-earmark-image': (this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'jpg' || this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'jpeg' || this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'png'),
                                            'bi-file-earmark-spreadsheet': (this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'xls' || this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'xlsx')
                                         }"></i>
                                        </div>
                                        <div class="document-info">
                                            <div class="document-name">{{doc['DocumentName']}}</div>
                                            <div class="document-details">
                                                <span class="document-number">{{doc['DocumentNumber']}}</span>
                                            </div>
                                        </div>
                                        <div class="document-actions">
                                            <a [href]="doc['FileLink']" target="_blank" role="button"
                                                class="btn-icon btn-view" title="View">
                                                <i class="bi bi-eye"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="version-panel new">
                                <div class="version-header">
                                    <span class="version-badge badge-new">
                                        <i class="bi bi-arrow-up-circle me-1"></i> NEW
                                    </span>
                                    <span class="text-muted">Updated documents</span>
                                </div>

                                <div class="documents-section">
                                    <div class="documents-section">
                                        <div class="document-item" *ngFor="let doc of EmpNewDocDetail; let i = index">
                                            <div class="document-icon" [ngClass]="{'icon-pdf': (this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'pdf' || this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'doc' || this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'docx'),
                                            'icon-image': (this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'jpg' || this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'jpeg' || this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'png'),
                                            'icon-excel': (this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'xls' || this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'xlsx')
                                         }">
                                                <i class="bi" [ngClass]="{'bi-file-earmark-pdf': (this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'pdf' || this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'doc' || this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'docx'),
                                            'bi-file-earmark-image': (this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'jpg' || this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'jpeg' || this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'png'),
                                            'bi-file-earmark-spreadsheet': (this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'xls' || this.common.ToLowerCase(doc['FileName'].split('.')[doc['FileName'].split('.').length-1]) == 'xlsx')
                                         }"></i>
                                            </div>
                                            <div class="document-info">
                                                <div class="document-name">{{doc['DocumentName']}}</div>
                                                <div class="document-details">
                                                    <span class="document-number">{{doc['DocumentNumber']}}</span>
                                                </div>
                                            </div>
                                            <div class="document-actions">
                                                <a [href]="doc['FileLink']" target="_blank" role="button"
                                                    class="btn-icon btn-view" title="View">
                                                    <i class="bi bi-eye"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="OperationType === 'Nominee'">
                <div class="modal-container">
                    <!-- Header -->
                    <div class="modal-header">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <h4 class="mb-1"><i class="bi bi-people-fill me-2"></i>Nominee</h4>
                                <p class="mb-0 opacity-75">Review details before approval</p>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="dashboard">
                            <div class="card previous" style="border-radius: 4px;margin: 0.5rem;">
                                <div class="card-header">
                                    <div class="icon">P</div>
                                    <h2>Previous Nominee</h2>
                                </div>
                                <div class="table-container">
                                    <table id="previousTable">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Address1</th>
                                                <th>Address2</th>
                                                <th>Relationship Name</th>
                                                <th>Village City</th>
                                                <th>State Name</th>
                                                <th>District Name</th>
                                                <th>Taluka Name</th>
                                                <th>Pincode</th>
                                                <th>Birth Date</th>
                                                <th>Share</th>
                                                <th>Guardian</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let data of EmpOldDocDetail; let i = index">
                                                <td>{{data['Name']}}</td>
                                                <td>{{data['Address1']}}</td>
                                                <td>{{data['Address2']}}</td>
                                                <td>{{data['RelationshipName']}}</td>
                                                <td>{{data['VillageCity']}}</td>
                                                <td>{{data['StateName'] }}</td>
                                                <td>{{data['DistrictName']}}</td>
                                                <td>{{data['TalukaName']}}</td>
                                                <td>{{data['Pincode']}}</td>
                                                <td>{{data['BirthDate']}}</td>
                                                <td>{{data['Share']}}</td>
                                                <td>{{data['Guardian']}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="card previous" style="border-radius: 4px;margin: 0.5rem;">
                                <div class="card-header">
                                    <div class="icon">N</div>
                                    <h2>New Nominee</h2>
                                </div>
                                <div class="table-container">
                                    <table id="newTable">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Address1</th>
                                                <th>Address2</th>
                                                <th>Relationship Name</th>
                                                <th>Village City</th>
                                                <th>State Name</th>
                                                <th>District Name</th>
                                                <th>Taluka Name</th>
                                                <th>Pincode</th>
                                                <th>Birth Date</th>
                                                <th>Share</th>
                                                <th>Guardian</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let data of EmpNewDocDetail; let i = index">
                                                <td>{{data['Name']}}</td>
                                                <td>{{data['Address1']}}</td>
                                                <td>{{data['Address2']}}</td>
                                                <td>{{data['RelationshipName']}}</td>
                                                <td>{{data['VillageCity']}}</td>
                                                <td>{{data['StateName'] }}</td>
                                                <td>{{data['DistrictName']}}</td>
                                                <td>{{data['TalukaName']}}</td>
                                                <td>{{data['Pincode']}}</td>
                                                <td>{{data['BirthDate']}}</td>
                                                <td>{{data['Share']}}</td>
                                                <td>{{data['Guardian']}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="OperationType === 'Dependent'">
                <div class="modal-container">
                    <!-- Header -->
                    <div class="modal-header">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <h4 class="mb-1"><i class="bi bi-people me-2"></i>Dependent</h4>
                                <p class="mb-0 opacity-75">Review details before approval</p>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="dashboard">
                            <div class="card previous" style="border-radius: 4px;margin: 0.5rem;">
                                <div class="card-header">
                                    <div class="icon">P</div>
                                    <h2>Previous Dependent</h2>
                                </div>
                                <div class="table-container">
                                    <table id="previousTable">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Address Type Name</th>
                                                <th>Relationship Name</th>
                                                <th>Date Of Birth</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let site of EmpOldDocDetail; let i = index">
                                                <td>{{site['Name']}}</td>
                                                <td>{{site['AddressTypeName']}}</td>
                                                <td>{{site['RelationshipName']}}</td>
                                                <td>{{site['DateOfBirth']}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="card previous" style="border-radius: 4px;margin: 0.5rem;">
                                <div class="card-header">
                                    <div class="icon">N</div>
                                    <h2>New Dependent</h2>
                                </div>
                                <div class="table-container">
                                    <table id="previousTable">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Address Type Name</th>
                                                <th>Relationship Name</th>
                                                <th>Date Of Birth</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let site of EmpNewDocDetail; let i = index">
                                                <td>{{site['Name']}}</td>
                                                <td>{{site['AddressTypeName']}}</td>
                                                <td>{{site['RelationshipName']}}</td>
                                                <td>{{site['DateOfBirth']}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end notification-action">
            <button type="button" class="btn btn-primary" [disabled]="isDisabled" (click)="Cancel()"><i
                    class="bi bi-arrow-left" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Cancel':'Loading...'}}</button>
            <button *ngIf="(common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(TrackingsUser.length > 0?TrackingsUser[0]['Status']:'') == 'pending' && GetID == 1) || 
                (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && isSuper && GetID == 1)" type="button"
                class="btn btn-danger" [disabled]="isDisabled" (click)="ApprovalMatrixRequestProcess('Reject')"><i
                    class="bi bi-x" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Reject':'Loading...'}}</button>

            <button *ngIf="(common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(TrackingsUser.length > 0?TrackingsUser[0]['Status']:'') == 'pending' && GetID == 1) || 
                (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && isSuper && GetID == 1)" type="button"
                class="btn btn-success" [disabled]="isDisabled" (click)="ApprovalMatrixRequestProcess('Approve')"><i
                    class="bi bi-check2" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Approve':'Loading...'}}</button>
        </div>
    </div>
</div>